<section class="requests-section" aria-live="polite">
  @if (loading()) {
    <p>Loading API key requests...</p>
  } @else if (errorMessage()) {
    <p class="error-message">{{ errorMessage() }}</p>
  } @else if (rows().length === 0) {
    <p>No pending API key requests.</p>
  } @else {
    <table class="requests-table">
      <caption class="sr-only">Pending API key requests grouped by user</caption>
      <thead>
      <tr>
        <th scope="col">User</th>
        <th scope="col">Organization</th>
        <th scope="col">Requested Keys</th>
        <th scope="col">Details</th>
      </tr>
      </thead>
      <tbody>
        @for (row of rows(); track row.userId) {
          <tr>
            <th scope="row">{{ row.userName }}</th>
            <td>{{ row.organization }}</td>
            <td>{{ row.requestedKeyCount }}</td>
            <td>
              <button
                mat-stroked-button
                type="button"
                [attr.aria-expanded]="isExpanded(row.userId)"
                (click)="toggleExpanded(row.userId)">
                {{ isExpanded(row.userId) ? 'Hide details' : 'View details' }}
              </button>
            </td>
          </tr>

          @if (isExpanded(row.userId)) {
            <tr>
              <td class="details-cell" colspan="4">
                <div class="details-content">
                  @for (request of row.requests; track request.requestId) {
                    <article class="request-card">
                      <dl>
                        <dt>Request Reason</dt>
                        <dd>{{ request.requestReason }}</dd>

                        <dt>Number of Requested Keys</dt>
                        <dd>{{ request.requestedKeysCount }}</dd>

                        <dt>Organization</dt>
                        <dd>{{ request.organization }}</dd>

                        <dt>Date Requested</dt>
                        <dd>{{ request.requestedAt | date: 'mediumDate' }}</dd>

                        <dt>How Many Users It Supports</dt>
                        <dd>{{ request.supportedUsersCount }}</dd>
                      </dl>

                      <button
                        mat-flat-button
                        color="primary"
                        type="button"
                        [disabled]="isApproving(request.requestId)"
                        (click)="approveRequest.emit(request.requestId)">
                        {{ isApproving(request.requestId) ? 'Processing...' : 'Approve Request' }}
                      </button>

                      <button
                        mat-stroked-button
                        color="warn"
                        type="button"
                        [disabled]="isApproving(request.requestId)"
                        (click)="denyRequest.emit({ requestId: request.requestId, userName: row.userName })">
                        Deny Request
                      </button>
                    </article>
                  }
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  }
</section>

